import {OpaqueToken} from "@angular/core";
import {CartItemJSON} from "cart-shared";
import {CartItem} from "purchasing/cart/cart-item";
import {Observable} from "rxjs";


export interface CartItemLinkerService {
	canLinkCartItem(cartItemJSON: CartItemJSON): boolean;
	linkCartItem(cartItemJSON: CartItemJSON): Observable<CartItem>;
}

// TODO: Convert to InjectionToken once we're not longer using this from Angular 2
export const CART_ITEM_LINKERS = new OpaqueToken("CartItemLinkerService");
